const sumInventory = (storeInventory) =>
	Object.values(storeInventory).reduce((sum, inventory) => sum + inventory?.quantity || 0, 0);

export class Product {
	id = null;
	name = null;
	price = 0;
	variants = [];

	constructor(data) {
		Object.assign(this, data);

		if (data.variants) {
			this.variants = data.variants.map((variant) => ({ productId: this.id, ...variant }));
		}
	}

	get featuredImage() {
		return this.images[0] || null;
	}

	getPrice() {
		return parseFloat(this.price || 0);
	}

	getVariantPrice(variantId) {
		const variant = this.variants.find((v) => v.id === variantId);
		if (!variant) return this.getPrice();

		return parseFloat(variant.price || this.price || 0);
	}

	static mapProductsAndVariants(products, discountProducts) {
		const result = {
			products: [],
		};

		discountProducts.forEach((discountProduct) => {
			if (discountProduct.variantId) {
				const product = products.find((product) => product.id == discountProduct.id);
				if (product) {
					const variant = product.variants.find(
						(variant) => variant.id == discountProduct.variantId,
					);
					if (variant) {
						result.products.push({ ...variant, id: product.id, variantId: variant.id });
					}
				}
			} else {
				const product = products.find((product) => product.id == discountProduct.id);
				if (product) {
					result.products.push(product);
				}
			}
		});

		return result;
	}

	static getInventory(product, storeId = null) {
		if (product.isUnlimitedStock) {
			return Number.POSITIVE_INFINITY;
		}

		if (!storeId) {
			if (product.variants && product.variants.length > 0) {
				return product.variants.reduce(
					(sum, variant) => sum + sumInventory(variant.storeInventory),
					0,
				);
			}
			return sumInventory(product.storeInventory);
		}
		if (product.variants && product.variants.length > 0) {
			return product.variants.reduce(
				(sum, variant) => sum + variant.storeInventory?.[storeId]?.quantity,
				0,
			);
		}
		return product.storeInventory?.[storeId]?.quantity || 0;
	}

	static getVariantInventory(variant, storeId = null) {
		if (!storeId) {
			return sumInventory(variant.storeInventory);
		}
		return variant.storeInventory?.[storeId]?.quantity || 0;
	}

	static getProductPrice(product) {
		return parseFloat(product.price || 0);
	}

	static getVariantPrice(variant) {
		return parseFloat(variant.price || 0);
	}
}
